/**
 * @generated SignedSource<<7f38d1b6237aafe6550f2b9bc8f46222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AudioContentFragment_content$data = {
  readonly audioProperties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly emoji: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly history: {
    readonly createdBy: {
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null;
    readonly ownedBy: {
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly links: {
    readonly base: string | null;
    readonly webui: string | null;
  } | null;
  readonly subType: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "AudioContentFragment_content";
};
export type AudioContentFragment_content$key = {
  readonly " $data"?: AudioContentFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"AudioContentFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "value"
},
v2 = [
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "profilePicture",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "path"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AudioContentFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "alias": "emoji",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "emoji-title-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        }
      ],
      "storageKey": "properties(key:\"emoji-title-published\")"
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "name": "ownedBy",
          "plural": false,
          "selections": (v2/*: any*/)
        }
      ]
    },
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        },
        {
          "kind": "ScalarField",
          "name": "base"
        }
      ]
    },
    {
      "alias": "audioProperties",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "emoji-title-published",
            "editor"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "b232c7e0b2db86037e433e186b56a94e";

export default node;
